/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'copy-price': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 9)" _stroke="#D8D8D8"><path pid="0" d="M2.386 5.913H.702a.34.34 0 00-.306.196.354.354 0 00.038.366l6.798 8.83a.338.338 0 00.536 0l6.798-8.83a.354.354 0 00.038-.366.34.34 0 00-.306-.195h-1.684"/><path pid="1" d="M.702.348a.34.34 0 00-.306.196.354.354 0 00.038.366l6.798 8.83a.338.338 0 00.536 0L14.566.908a.354.354 0 00.038-.367.34.34 0 00-.306-.196L.702.348z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/copy-price.js